import { createTheme } from "@mui/material/styles";

import { breakpoints } from "@/theme/breakpoints";
import { typography } from "@/theme/typography";
import { components } from "@/theme/components";
import { button, text } from "@/theme/colors";

const theme = createTheme({
  breakpoints,
  typography,
  components,
  palette: {
    primary: {
      light: button.hover_02,
      main: button.primary,
      dark: button.pressed,
      contrastText: text.white,
    },
  },
});

export default theme;
